
import { mapState } from 'vuex' // 引入mapState
import userHeader from './userHeader.vue' // 头部
import userTabs from './usersTabs.vue' // tab
import userCountry from './userCountry.vue' // 国家
import userThreparty from './userThreparty.vue' // 三方登录
import wikiGeet from './wikiGeet.vue' // 极验
import userGraphical from './userGraphical.vue' // 图形验证码
export default {
  components: {
    'user-header': userHeader,
    'user-tabs': userTabs,
    'user-country': userCountry,
    'user-threparty': userThreparty, // 三方登录
    'wiki-geet': wikiGeet,
    'user-graphical': userGraphical
  },
  props: {
    signState: {
      // 为 2展示邮箱登录
      type: [Number, String],
      default: 1
    },
    mobile: {
      // 是否为移动端
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false, // 接口请求中
      mobileNumber: this.$store.state.myCountry.toLowerCase() == 'cn' ? 1 : 2,
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      tabs: [
        { name: this.$v('手机验证码'), type: 1 },
        { name: this.$v('邮箱/账号'), type: 2 }
      ],
      // 验证码登录
      showDrag: false, // 极验是否展示
      graphicalState: false, // 图形验证码是否展示
      product: 'bind', // 极验展示效果
      roTade: false, // 国家点击下拉框状态
      phoneState: false, // 手机号聚焦
      smsState: false, // 验证码聚焦
      emailState: false, // 邮箱聚焦
      countDown: 0, // 倒计时秒数
      iscountdown: false, // 是否开始倒计时
      idType: 1, // 1邮箱/2账号
      signin: {
        // 登录数据
        phone: '', // 手机号
        phoneError: '', // 手机号报错
        sms: '', // 验证码
        smsError: '', // 验证码报错
        figuresmsError: '', // 图形验证码报错
        requestId: '', // 获取验证码id
        email: '', // 邮箱or账号绑定
        emailError: '', // 邮箱错误
        isregistered: null // 手机号是否注册
      },
      fingerprint: this.$cookies.get('wiki-bfp') // 浏览器指纹
    }
  },
  computed: {
    ...mapState(['usergetCountry']), // 选中的国家
    title() {
      // 标题
      switch (this.mobileNumber) {
        case 1:
          return this.$route.query.type == 'register' ? this.$v('绑定账号') : this.$v('登录')
        case 2:
          return this.$route.query.type == 'register' ? this.$v('绑定账号') : this.$v('登录')
        case 3:
          return this.$v('验证码')
        case 4:
          return this.$v('语音验证')
        default:
          return this.$v('无头')
      }
    },
    btnState() {
      // this.signin.email.includes('@') ? reg.test(this.signin.email) :
      // 邮箱格式不正确
      if (this.mobileNumber == 1 && this.signin.phone && this.signin.sms) {
        return true
      } else if (this.mobileNumber == 2 && this.signin.email && this.signin.email.length > 4) {
        return true
      } else {
        return false
      }
    }
  },
  created() {},
  mounted() {
    if (this.signState != 1) this.mobileNumber = 2
    document.addEventListener('click', this.coutryClose, { passive: true })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    countryChange(i) {
      console.log('i: ', i)
      this.signin.phone = this.signin.phoneError = this.signin.sms = this.signin.smsError = this.signin.figuresmsError = this.signin.requestId = this.signin.email = this.signin.emailError = ''
      this.showDrag = this.roTade = this.phoneState = this.smsState = this.emailState = this.loading = this.iscountdown = false
    },
    forget() {
      this.signin.phone = this.signin.phoneError = this.signin.sms = this.signin.smsError = this.signin.figuresmsError = this.signin.requestId = this.signin.email = this.signin.emailError = ''
      this.showDrag = this.roTade = this.phoneState = this.smsState = this.emailState = this.loading = this.iscountdown = false
      this.$emit('loginSwitch', 3)
    },
    coutryClose(e) {
      // 点击非组件区域关闭下拉框
      if (!this.$el.contains(e.target)) this.roTade = false
    },
    switstat(i) {
      // tab栏切换
      // console.log('进入清空')
      this.signin.phone = this.signin.phoneError = this.signin.sms = this.signin.smsError = this.signin.figuresmsError = this.signin.requestId = this.signin.email = this.signin.emailError = ''
      this.showDrag = this.roTade = this.phoneState = this.smsState = this.emailState = this.loading = this.iscountdown = false
      this.countDown = 0
      this.mobileNumber = i // 显示状态  1为手机验证码  2为手机号/邮箱登录
      console.log('this.mobileNumber: ', this.mobileNumber)
      this.roTade = false // 国家隐藏
    },
    sendcode() {
      // 获取验证码
      if (this.usergetCountry.code == '0086') {
        // 如果为国内则走国内手机号验证
        if (!this.signin.phone) {
          this.signin.phoneError = this.$v('手机号格式不正确')
          return false
        }
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (myreg.test(this.signin.phone)) {
          // console.log('验证手机号成功')
          this.signin.phoneError = '' // 验证成功则错误消息清空
          return true
        } else {
          this.signin.phoneError = this.$v('手机号格式不正确')
          return false
        }
      } else {
        // 否则走国外手机号验证
        if (!this.signin.phone) {
          this.signin.phoneError = this.$v('手机号格式不正确')
          return false
        }
        const myreg = /^.{5,20}$/
        if (myreg.test(this.signin.phone)) {
          this.signin.phoneError = '' // 验证成功则错误消息清空
          return true
        } else {
          this.signin.phoneError = this.$v('手机号格式不正确')
          return false
        }
      }
    },
    getcode() {
      // 发送验证码
      if (this.$route.query.type == 'register' && this.sendcode()) {
        this.triparphone(1)
      } else if (this.sendcode()) {
        this.showDrag = true // 极验框展示
        setTimeout(() => {
          this.showDrag = false
        }, 300)
      }
    },
    async checkphone() {
      // 校验手机号是否注册
      const getnewsendcodev2 = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phoneNumber: this.signin.phone
          },
          {
            Routes: 'usercenter$newusercenterphoneisregisterv2'
          }
        )
        .catch(() => {
          console.log('newusercenterphoneisregisterv2')
        })
      if (getnewsendcodev2 && getnewsendcodev2.usercenter && getnewsendcodev2.usercenter.newusercenterphoneisregisterv2) {
        if (!getnewsendcodev2.usercenter.newusercenterphoneisregisterv2.success) return this.$message.error(getnewsendcodev2.usercenter.newusercenterphoneisregisterv2.extra) // 数据错误
        this.signin.isregistered = getnewsendcodev2.usercenter.newusercenterphoneisregisterv2.data.isregister // 该手机号是否注册
        if (this.signin.isregistered)
          this.phflatlogin() // 手机号登录
        else this.phregister() // 手机号注册
      }
    },
    async triparphone(i) {
      // 三方流程
      const thirdphoneverifyv3 = await this.$api.common
        .CV3(
          {
            AreaCode: this.usergetCountry.code,
            PhoneNubmer: this.signin.phone,
            AccountType: this.$route.query.logintype
          },
          {
            Routes: 'usercenter$thirdphoneverifyv3'
          }
        )
        .catch(() => {
          console.log('thirdphoneverifyv3')
        })
      console.log('thirdphoneverifyv3: ', thirdphoneverifyv3)
      if (thirdphoneverifyv3 && thirdphoneverifyv3.usercenter && thirdphoneverifyv3.usercenter.thirdphoneverifyv3) {
        if (!thirdphoneverifyv3.usercenter.thirdphoneverifyv3.success) {
          this.signin.phoneError = thirdphoneverifyv3.usercenter.thirdphoneverifyv3.extra
          this.loading = false
          return
        } // 数据错误
        this.signin.phoneError = ''
        if (i == 1) {
          // 验证码点击
          this.showDrag = true // 极验框展示
          setTimeout(() => {
            this.showDrag = false
          }, 300)
        } else if (i == 2) {
          // 登录点击
          this.triparphonelogin()
        }
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    async triparphonelogin() {
      // 手机号三方注册
      // usercenter$thridphoneregisterv3
      const thridphoneregisterv3 = await this.$api.common
        .CV3(
          {
            openId: this.$route.query.id,
            accountNick: this.$route.query.name && this.$route.query.name != 'null' ? this.$route.query.name : '',
            accountHead: this.$route.query.img && this.$route.query.img != 'null' ? this.$route.query.img : '',
            accountType: this.$route.query.logintype,
            areaCode: this.usergetCountry.code,
            areaFlag: this.usergetCountry.flag,
            phone: this.signin.phone,
            deviceInformation: 'web',
            version: 124,
            registrationPlatform: 0,
            deviceCode: this.fingerprint, // 指纹
            msgCode: this.signin.sms,
            registrationType: 112,
            applicationType: 7,
            countryCode: this.usergetCountry.countryCode,
            languageCode: this.LanguageCode,
            registrationip: this.$store.state.userIp
          },
          {
            Routes: 'usercenter$thridphoneregisterv3'
          }
        )
        .catch(() => {
          console.log('thridphoneregisterv3')
        })
      if (thridphoneregisterv3 && thridphoneregisterv3.usercenter && thridphoneregisterv3.usercenter.thridphoneregisterv3) {
        this.loading = false
        if (!thridphoneregisterv3.usercenter.thridphoneregisterv3.success) return (this.signin.smsError = thridphoneregisterv3.usercenter.thridphoneregisterv3.extra)
        this.signin.smsError = ''
        this.accessCookie(thridphoneregisterv3.usercenter.thridphoneregisterv3.data)
      }
    },
    logoIn() {
      // 触发登录
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ // 邮箱校验
      const phoneNum = /^[0-9]*$/ // 正则表达式
      const phonefn = new RegExp(phoneNum)
      if (this.btnState) {
        if (this.mobileNumber == 1 && this.signin.phone && this.signin.sms) {
          // 手机号登录/注册
          if (this.sendcode()) {
            // 校验手机号是否通过
            if (this.loading) return
            this.loading = true
            // 判断是否为三方注册
            this.$route.query.type == 'register' ? this.triparphone(2) : this.checkphone()
          }
        } else if (this.mobileNumber == 2 && this.signin.email) {
          if (this.signin.email.includes('@')) {
            if (reg.test(this.signin.email)) {
              this.signin.emailError = ''
              // this.$emit('emailSwitch', 2, this.signin.email)
              this.idType = 1 // 邮箱
              this.checkemail()
            } else {
              this.signin.emailError = this.$v('邮箱格式不正确')
            }
          } else if (this.$route.query.type != 'register' && this.signin.email.length > 4 && phonefn.test(this.signin.email)) {
            this.signin.emailError = ''
            // this.$emit('emailSwitch', 2, this.signin.email)
            this.idType = 2 // 手机号
            this.checkemail()
          } else {
            this.signin.emailError = this.$route.query.type != 'register' ? this.$v('账号格式不正确') : this.$v('邮箱格式不正确')
          }
        }
      }
    },
    async checkemail() {
      if (this.loading) return
      this.loading = true
      const accountisregister = await this.$api.common
        .CV3(
          {
            account: this.signin.email
          },
          {
            Routes: 'usercenter$accountisregister'
          }
        )
        .catch(() => {
          console.log('accountisregister')
        })
      if (accountisregister && accountisregister.usercenter && accountisregister.usercenter.accountisregister) {
        if (this.idType == 1) {
          // 为邮箱时直接跳转
          if (this.$route.query.type != 'register' || !accountisregister.usercenter.accountisregister.data) {
            // 不为三方流程 || 邮箱未注册
            this.$emit('emailSwitch', 2, this.signin.email, accountisregister.usercenter.accountisregister.data)
          } else if (accountisregister.usercenter.accountisregister.data) {
            this.bindingEmail()
          }
        } else if (this.idType == 2) {
          // 手机号
          if (accountisregister.usercenter.accountisregister.data) this.$emit('emailSwitch', 2, this.signin.email, accountisregister.usercenter.accountisregister.data)
          else this.signin.emailError = this.$v('账号格式不正确')
        }
        this.loading = false
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    async bindingEmail() {
      // 是否绑定邮箱
      const thirdemailverifyv3 = await this.$api.common
        .CV3(
          {
            Email: this.signin.email,
            AccountType: this.$route.query.logintype
          },
          {
            Routes: 'usercenter$thirdemailverifyv3'
          }
        )
        .catch(() => {
          console.log('thirdemailverifyv3')
        })
      if (thirdemailverifyv3 && thirdemailverifyv3.usercenter && thirdemailverifyv3.usercenter.thirdemailverifyv3) {
        if (!thirdemailverifyv3.usercenter.thirdemailverifyv3.success) return (this.signin.emailError = thirdemailverifyv3.usercenter.thirdemailverifyv3.extra)
        this.signin.emailError = ''
        this.$emit('emailSwitch', 2, this.signin.email, true)
      }
    },
    async phflatlogin() {
      // 手机号登录
      const loginPhone = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code, // 国家code
            phone: this.signin.phone, // 手机号
            msgCode: this.signin.sms, // 验证码
            requestId: this.signin.requestId, // 极验之后的requestId
            version: 124, // 版本号
            applicationType: 7, // 项目类型
            countryCode: this.usergetCountry.countryCode, // 国家code
            languageCode: this.LanguageCode, // 页面语言
            ip: this.$store.state.userIp // 用户ip
          },
          {
            Routes: 'usercenter$newusercenterphonequickloginv2'
          }
        )
        .catch(() => {
          console.log('newusercenterphonequickloginv2')
        })
      if (loginPhone && loginPhone.usercenter && loginPhone.usercenter.newusercenterphonequickloginv2) {
        this.loading = false
        if (!loginPhone.usercenter.newusercenterphonequickloginv2.success) return (this.signin.smsError = loginPhone.usercenter.newusercenterphonequickloginv2.extra)
        this.signin.smsError = ''
        this.accessCookie(loginPhone.usercenter.newusercenterphonequickloginv2.data)
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    async phregister() {
      // 手机号注册
      const phoneregisterv3 = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code, // 国家code
            areaFlag: this.usergetCountry.flag, // 国家国旗
            phone: this.signin.phone, // 手机号
            deviceInformation: 'web',
            version: 124, // 版本号
            registrationPlatform: 0,
            deviceCode: this.fingerprint,
            msgCode: this.signin.sms,
            registrationType: 112,
            applicationType: 7, // 项目类型
            countryCode: this.usergetCountry.countryCode, // 国家code
            languageCode: this.LanguageCode,
            registrationip: this.$store.state.userIp // 用户ip
          },
          {
            Routes: 'usercenter$phoneregisterv3'
          }
        )
        .catch(() => {
          console.log('phoneregisterv3')
        })
      if (phoneregisterv3 && phoneregisterv3.usercenter && phoneregisterv3.usercenter.phoneregisterv3) {
        this.loading = false
        if (!phoneregisterv3.usercenter.phoneregisterv3.success) return (this.signin.smsError = phoneregisterv3.usercenter.phoneregisterv3.extra) // 数据错误
        this.signin.smsError = ''
        this.accessCookie(phoneregisterv3.usercenter.phoneregisterv3.data)
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    async sendVCode(data = {}) {
      // 极验成功后发送验证码
      const { phone = '' } = this.signin // 手机号为空true/false
      if (!phone) return false
      const getnewsendcodev2 = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone,
            languageCode: this.LanguageCode,
            msgType: 0,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge
          },
          {
            Routes: 'usercenter$newsendcodev2'
          }
        )
        .catch(() => {
          console.log('newsendcodev2')
        })
      if (getnewsendcodev2 && getnewsendcodev2.usercenter && getnewsendcodev2.usercenter.newsendcodev2) {
        if (!getnewsendcodev2.usercenter.newsendcodev2.success) return (this.signin.smsError = getnewsendcodev2.usercenter.newsendcodev2.extra) // 数据错误
        this.signin.smsError = ''
        this.signin.requestId = getnewsendcodev2.usercenter.newsendcodev2.data.requestid
        this.showDrag = false // 隐藏拖拽框
        this.countDown = 60
        this.iscountdown = true // 是否开始倒计时
        this.startCount() // 开始倒计时
      }
    },
    async figuresms(sms) {
      // 图形验证码成功后发送验证码
      const { phone = '' } = this.signin // 手机号为空true/false
      if (!phone) return false
      const getnewsendcodev2 = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone,
            languageCode: this.LanguageCode,
            msgType: 0,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: '',
            GeetestChallenge: '',
            graphCode: sms
          },
          {
            Routes: 'usercenter$newsendcodev2'
          }
        )
        .catch(() => {
          console.log('newsendcodev2')
        })
      if (getnewsendcodev2 && getnewsendcodev2.usercenter && getnewsendcodev2.usercenter.newsendcodev2) {
        console.log('getnewsendcodev2.usercenter.newsendcodev2: ', getnewsendcodev2.usercenter.newsendcodev2)
        if (!getnewsendcodev2.usercenter.newsendcodev2.success) return (this.signin.figuresmsError = getnewsendcodev2.usercenter.newsendcodev2.extra) // 数据错误
        this.signin.figuresmsError = '' // 错误置空
        this.graphicalState = false // 图形弹框关闭
        this.signin.requestId = getnewsendcodev2.usercenter.newsendcodev2.data.requestid
        this.showDrag = false // 隐藏拖拽框
        this.countDown = 60
        this.iscountdown = true // 是否开始倒计时
        this.startCount() // 开始倒计时
      }
    },
    // 验证码登录——开始倒计时
    startCount() {
      this.countDown--
      if (this.countDown < 1) {
        // 倒计时结束
        clearTimeout(this.vTimer)
        this.countimes++
        this.iscountdown = false // 倒计时关闭
        return true
      }
      this.vTimer = setTimeout(this.startCount, 1000)
    },
    geetError() {
      // 极验错误
      this.showDrag = false // 极验框状态取消
      this.graphicalState = true // 图形验证弹出
    },
    async accessCookie(userInfo) {
      // 加密cookie存cookie
      this.$store.commit('setUser', {
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick || userInfo.nickName,
        avatar: userInfo.showAvataraddress || userInfo.avatar || userInfo.profilePhoto
      })
      if (userInfo?.LoginToken?.expires_in) {
        const ntoken = `${userInfo?.LoginToken?.token_type} ${userInfo?.LoginToken?.access_token}`
        this.$cookies.set('logintoken', ntoken, {
          domain: this.$store.state.cookieHost,
          maxAge: userInfo?.LoginToken?.expires_in,
          path: '/'
        }) // 存储token
        this.$cookies.set('quitetoken', `${userInfo?.LoginToken?.access_token},${userInfo?.LoginToken?.refresh_token}`, {
          // 获取退出时所需要的access_token-refresh_token
          domain: this.$store.state.cookieHost,
          maxAge: userInfo?.LoginToken?.expires_in,
          path: '/'
        }) // 存储token
        this.$cookies.set('refreshtime', String(new Date().getTime()), {
          // 刷新时间
          domain: this.$store.state.cookieHost,
          maxAge: userInfo?.LoginToken?.expires_in,
          path: '/'
        }) // 存储token
        this.$store.commit('loginverifyfn', false)
      }
      const getcookie = await this.$api.common
        .CV3(
          // 信息加密
          {
            userId: userInfo.userId,
            nick: userInfo.showNickName || userInfo.nick || userInfo.nickName,
            avatar: userInfo.showAvataraddress || userInfo.avatar || userInfo.profilePhoto
          },
          {
            Routes: 'usercenter$getcookie'
          }
        )
        .catch(() => {
          console.log('getcookie')
        })
      if (getcookie && getcookie.usercenter && getcookie.usercenter.getcookie) {
        if (!getcookie.usercenter.getcookie.success) return this.$message.error(getcookie.usercenter.getcookie.extra) // 数据错误
        if (this.$store.state.host.includes('wikifx')) {
          this.CookieSet('DJkdikKMG', getcookie.usercenter.getcookie.data.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
        } else if (this.$store.state.host.includes('fxeye')) {
          this.CookieSet('ViLartidlakd', getcookie.usercenter.getcookie.data.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
        } else {
          this.$cookies.set('WsdsfgDGdagYms', getcookie.usercenter.getcookie.data.Value)
          const postdata = {
            op_type: 'setCookie',
            url: '',
            parm: getcookie.usercenter.getcookie.data.Value
          }
          window.parent.postMessage(postdata, '*')
        }
      }
      this.$store.commit('setUsercookie', getcookie.usercenter.getcookie.data.Value)
      const postdata = {
        op_type: 'reload',
        url: '',
        parm: getcookie.usercenter.getcookie.data.Value
      }
      window.parent && window.parent.postMessage(postdata, '*')

      if (this.mobileNumber == 1 && !this.signin.isregistered && userInfo.userStatus == 3) this.$emit('popjoinflow')
      else {
        this.$emit('close')
        if (this.$store.state.path.includes('login.html')) {
          setTimeout(() => {
            if (process.client) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
          }, 1500)
        }
      }
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
